export default function InputField({
  icon,
  placeholder,
  type = "text",
  value,
  onChange,
  onBlur,
  onFocus,
  rightIcon,
  onRightIconClick,
  rightAriaLabel,
  name,
  autoComplete
}) {
  return (
    <div className="input-box">
      <span className="icon">{icon}</span>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        name={name}
        autoComplete={autoComplete}
      />
      {rightIcon ? (
        <button
          type="button"
          className="input-action"
          onClick={onRightIconClick}
          aria-label={rightAriaLabel || "Toggle password visibility"}
        >
          {rightIcon}
        </button>
      ) : null}
    </div>
  );
}
